import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { setModal } from '../redux/modalSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faGear } from '@fortawesome/free-solid-svg-icons'

export default function LoanServiceButtons(props) {
  const { customerLocked, submitUnlock, active, loanId, currentDate, refreshPaymentSchedule, availablePaymentMethods, loanData } = props
  const dispatch = useDispatch()

  const [isActive, setIsActive] = useState(false);
  const node = useRef();

  const handleClick = () => {
    setIsActive(!isActive);
  }

  const handleChangePaymentMethodClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'change_payment_method_modal',
        options: {
          loanId: loanId,
          currentDate: currentDate,
          availablePaymentMethods: availablePaymentMethods,
          successCallback: () => refreshPaymentSchedule()
        }
      })
    )
    submitUnlock(1)
    handleClick()
  }

  const handleUnholdPaymentsClick = () => {
    dispatch(
      setModal({
        is_active: true,
        type: 'unhold_payments_modal',
        options: {
          loanId: loanId,
          currentDate: currentDate,
          successCallback: () => refreshPaymentSchedule()
        }
      })
    )
  }

  const handleClickOutside = (event) => {
    if (node.current.contains(event.target)) {
      return;
    }
    setIsActive(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`dropdown is-up is-right ${isActive ? 'is-active' : ''} control`} ref={node}>
      <div className="dropdown-trigger">
        <button type="button" className="button no-hover has-background-grey has-text-white is-size-5 mr-1" style={{ height: "fit-content" }} onClick={handleClick} disabled={customerLocked}>
          <FontAwesomeIcon icon={faGear} size="1x" />
        </button>
      </div>
      <div className="dropdown-menu has-text-left" id="dropdown-menu" role="menu">
        <div className="dropdown-content">
          <a
            className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
            onClick={handleChangePaymentMethodClick}
            style={loanData?.can_not_change_payment_methods_reason ? { pointerEvents: 'none', color: 'grey' } : {}}
          >
            Change Payment Method
            {loanData?.can_not_change_payment_methods_reason && (
              <span
                style={{ pointerEvents: 'auto' }}
                className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary has-text-weight-normal`}
                data-tooltip={loanData?.can_not_change_payment_methods_reason}
              >
                      <FontAwesomeIcon
                        icon={faCircleInfo}
                        className={`pl-1 has-text-link`}
                      />
            </span>
            )}
          </a>

          <a
            className={`dropdown-item ${customerLocked ? "disabled-menu-item" : ""}`}
            style={!loanData?.can_unhold_all_payments ? { pointerEvents: 'none', color: 'grey' } : {}}
            onClick={handleUnholdPaymentsClick}
          >
            Unhold Payments
          </a>

        </div>
      </div>
    </div>
  )
}
